<template>
    <div class="index_search">
        <div class="search_box">
            <el-date-picker
                v-model="times"
                type="monthrange"
                @change="changeTime"
                range-separator="~"
                popper-class="monthrange"
                value-format="yyyy-MM"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <div class="tabs_change">
                <div @click="changeCurrentTime(1)" :class="activeIndex==1?'activeTime':''">本月</div>
                <div @click="changeCurrentTime(2)" :class="activeIndex==2?'activeTime':''">本年</div>
            </div>
        </div>
        <div class="search_num_count">
            <div class="search_num_count_row">
                <div>交易量</div>
                <div><span>145</span>宗</div>
            </div>
            <div class="search_num_count_row">
                <div>交易额</div>
                <div><span>100.00</span>亿元</div>
            </div>
            <div class="search_num_count_row">
                <div>节约金额</div>
                <div><span>13.48</span>亿元</div>
            </div>
            <div class="search_num_count_row">
                <div>节约率</div>
                <div><span>12.12</span>%</div>
            </div>
        </div>
        
    </div>
</template>
<script>

export default {
    data(){
        return{
            times:'',
            activeIndex:''
        }
    },
    methods:{
        changeTime(){//改变时间框
            this.dealTime()
            // this.getData()
        },
        changeCurrentTime(type){//本年本月切换
            var date = new Date(); 
            var year=date.getFullYear(); 
            var month=date.getMonth()+1; 
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if(type==1){
                var activeTime=year+'-'+month;
                this.times=[activeTime,activeTime];
                this.activeIndex=1
            }else{
                this.times=[year+'-01',year+'-12']
                this.activeIndex=2
            }
            // this.getData()
        },
        dealTime(){//处理时间
            var date = new Date(); 
            var year=date.getFullYear(); 
            var month=date.getMonth()+1; 
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            var activeTime=year+'-'+month;
            if(this.times&&this.times.length==2){
                if(this.times[0]==this.times[1]&&this.times[0]==activeTime){
                    this.activeIndex=1
                }else if(this.times[0].substring(0,4)==year&&this.times[0]==year+'-01'&&this.times[1]==year+'-12') {
                    this.activeIndex=2
                }else{
                    this.activeIndex=''
                }
            }else{
                this.activeIndex=''
            }
        },
        
            
    }
}
</script>
<style lang="scss" scoped>
    .index_search{
        width: calc(100% - 996px);
        position: relative;
    }
    .search_box{
        margin-left: auto;
        margin-right: 18px;
        display: flex;
        align-items: center;
        margin-top: 31px;
        justify-content: flex-end;
        /deep/ .el-date-editor{
            background: rgba(24, 144, 255, 0.25);
            border: 1px solid #1890FF;
            .el-range-separator,.el-range-input{
                background: transparent;
                color: rgba(255,255,255, 0.85);
            }
            .el-range-separator{
                color: rgba(255,255,255, 0.85);
            }
        }
        .tabs_change{
            display: flex;
            border: 1px solid #3196FA;
            color: #FFFFFF;
            font-size: 14px;
            height: 32px;
            line-height: 32px;
            margin-left: 12px;
            border-radius: 4px;
            &>div{
                width: 56px;
                text-align: center;
                background: rgba(49, 150, 250, 0.25);
                cursor: pointer;
            }
            .activeTime{
                background: linear-gradient(208deg, #FFC00A 0%, rgba(255, 192, 10, 0) 100%);
                box-shadow: inset 0px 0px 7px 0px rgba(255, 192, 10, 0.5);
                border-radius: 4px 0px 0px 4px;
                opacity: 1;
                border: 1px solid #FFC00A;
            }
        }
    }
    .search_num_count{
        margin-top: 17px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .search_num_count_row{
            width: 25%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &>div:nth-of-type(1){
                font-size: 16px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 19px;
                margin-bottom: 8px;
                text-shadow: 0px 0px 6px rgba(24, 144, 255, 0.81);
            }
            &>div:nth-of-type(2){
                width: 176px;
                height: 64px;
                line-height: 64px;
                text-align: center;
                background: linear-gradient(90deg, rgba(24, 144, 255, 0) 0%, rgba(24, 144, 255, 0.25) 51%, rgba(24, 144, 255, 0) 100%);
                border-radius: 0px 0px 0px 0px;
                opacity: 1;
                border: 2px solid;
                border-image: linear-gradient(270deg, rgba(24, 144, 255, 0), rgba(92, 196, 255, 1), rgba(24, 144, 255, 0)) 2 2;
                color: rgba(255,255,255, 0.85);
                span{
                    font-family: DINCond-Black-Regular, DINCond-Black;
                    font-weight: 600;
                    color: #FFFFFF;
                    letter-spacing: 2px;
                    font-size: 36px;
                    text-shadow: 0px 0px 6px rgba(24, 144, 255, 0.81);
                    display: inline-block;
                    margin-right: 8px;
                }
            }
        }
        
    }
</style>